module.exports = __webpack_public_path__ + "assets/img/26_770_big.43118b1c.jpg";